module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1018-6807ebfd63090afb7d0ed94ec5a008e1.png";